import { render, staticRenderFns } from "./DrugInventoryList.vue?vue&type=template&id=375bb2df&scoped=true&"
import script from "./DrugInventoryList.vue?vue&type=script&lang=js&"
export * from "./DrugInventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375bb2df",
  null
  
)

export default component.exports